import { fromPairs, sortBy, split } from 'lodash-es';
import { Logger } from '@se/se.ui.html5';
/**
 * Ritrova i valori dei parametri nella url corrente.
 */
export function getQueryParams() {
    const queryParamsArr = window.location.search
        // Rimuovi '?' iniziale
        .substring(1)
        .split('&')
        .map((qp) => split(qp, '=', 2));

    return fromPairs(queryParamsArr);
}

function isTimingSupported() {
    return 'performance' in window;
}

export function logTime(fn, prefix?: string, logger?: Logger): unknown {
    const timeNow = isTimingSupported() ? () => window['performance'].now() : () => new Date().getTime();

    const startTime = timeNow();
    const returnValue: unknown = fn();
    const endTime = timeNow();

    let strPrefix = '';
    if (!!prefix) {
        strPrefix = `${prefix}: `;
    }

    const msg = `${strPrefix}${endTime - startTime}ms`;
    if (logger) {
        logger.trace(msg);
    } else {
        console.debug(msg);
    }

    return returnValue;
}

export function orderCollectionByStringProp(
    collection: any,
    property: any,
    trim: boolean = true,
    lowercase: boolean = true
) {
    const orderedCollection = sortBy(collection, (data) => {
        const splittedProp = data[property].split(' ');
        let comparerString = '';
        // Uso come comparatore la prima stringa non vuota, trimmata e lowercase
        for (let sp of splittedProp) {
            if (!!sp.trim()) {
                comparerString = sp;
                if (lowercase) {
                    comparerString = comparerString.toLowerCase();
                }
                if (trim) {
                    comparerString = comparerString.trim();
                }

                return comparerString;
            }
        }

        return data[property];
    });

    return orderedCollection;
}

export function arrayBufferToBase64(arrayBuffer) {
    let binary = '';
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    if (len > 0) {
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    return null;
}

export function convertBase64ToUint8Array(base64: string): Uint8Array {
    const raw = window.atob(base64);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }

    return array;
}

export function jsonBlob(obj: any) {
    return new Blob([JSON.stringify(obj)], { type: 'application/json' });
}
